import { useTranslation } from 'react-i18next';
﻿import React, { FunctionComponent, useEffect, useState } from "react";

import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { message } from "antd/lib";
import { get, isEmpty } from "lodash";
import { FormInstance } from "antd/lib";
import { useNavigate } from "react-router-dom";
import DrawerCustom from "../../../../../../components/drawer/Drawer";
import { UrlPattern, regexEmail } from "../../../../../../utils/regex";
import type { DatePickerProps } from "antd";
import { DatePicker, Select } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import { Input } from "antd";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Flex,
  Form,
  Row,
  Space,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import {
  CloseOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  SaveOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { useAuthStore } from "../../../../../../stores/stores";
import { useForm } from "antd/es/form/Form";
import FormInput from "../../../../../../components/form-input/FormInput";
import FormItemDropdown from "../../../../../../components/form-dropdown/FormItemDropdown";
import FormRadio from "../../../../../../components/form-radio/FormRadio";
import grapesjs, { Block, Editor } from "grapesjs";
import GjsEditor, { useEditor, WithEditor } from "@grapesjs/react";
import gjsBlocksBasic from "grapesjs-blocks-basic";
import gjsTailWind from "grapesjs-tailwind";
import gjsNavbar from "grapesjs-navbar";
import gjsPresetWeb from "grapesjs-preset-webpage";
import gjsStyleBg from "grapesjs-style-bg";
import gjsStyleFilter from "grapesjs-style-filter";
import gjsStyleGradient from "grapesjs-style-gradient";

import {
  getMoocCourseConstructionPlanById,
  getLookupAuthUser,
  getLookupMoocUniversity,
  getLookupIndustryGroup,
  getLookupIndustry,
  checkExistCodeName,
} from "../../../../../../service/course-plan-managment/mooc-course-construction-plan/moocCourseConstructionPlanApi";
import { DetailTypeMoocCourseConstructionPlan } from "../../../../../../types/course-plan-managment/mooc-course-construction-plan";
import { getLookupMoocUniversityHost } from "../../../../../../service/course-plan-managment/mooc-course-construction-plan/moocCourseConstructionPlanApi";
type FormCreateMoocCourseConstructionPlanProps = {
  onFinish?: any;
  dataOptions?: any;
  id?: any;
  detailData?: DetailTypeMoocCourseConstructionPlan;
  isOpened?: boolean;
  modeOpen: any;
  setIsOpened: React.Dispatch<React.SetStateAction<boolean>>;
  setDetailData?: React.Dispatch<
    React.SetStateAction<DetailTypeMoocCourseConstructionPlan>
  >;
  setDataUpdate?: (data: any) => void;
  setDataSponsorUpdate?: (data: any) => void;
};

export const FormCreateMoocCourseConstructionPlan: FunctionComponent<
  FormCreateMoocCourseConstructionPlanProps
> = ({
  onFinish,
  dataOptions,
  id,
  detailData,
  isOpened,
  setIsOpened,
  modeOpen,
  setDetailData,
  setDataUpdate,
  setDataSponsorUpdate,
}) => {
  const { t } = useTranslation();
  const validations = {
    id: {
      required: false,
      message: t("Vui lòng chọn khoa Title of id áp dụng", "Vui lòng chọn khoa Title of id áp dụng"),
      // validator: (_: unknown, value: string) => {
      //   value = "x";
      //   if (!value) {
      //     return Promise.reject(new Error(t("Vui lòng nhập tên Title of id", "Vui lòng nhập tên Title of id")));
      //   }
      //   return Promise.resolve();
      // },
    },
    registrationCode: {
      required: true,
      // message: t(t("Vui lòng nhập mã đăng ký", "Vui lòng nhập mã đăng ký"), t("Vui lòng nhập mã đăng ký", "Vui lòng nhập mã đăng ký")),
      validator: async (_: unknown, value: string) => {
        // if (value && value.length < 6) {
        //   return Promise.reject(
        //     new Error("Tên khóa học phải từ 6 ký tự trở lên")
        //   );
        // }
        if (value && value.length > 25) {
          return Promise.reject(
            new Error(t("Mã đăng ký khóa học không vượt quá 25 ký tự", "Mã đăng ký khóa học không vượt quá 25 ký tự"))
          );
        }
        if (value !== "") {
          if (modeOpen === "edit") {
            // console.log("edit")
            if (value !== detailData?.registrationCode) {
              // console.log("check di")
              await checkExistCodeName(value).then((res) => {
                if (res.data.data === true) {
                  return Promise.reject(
                    new Error(t("Mã đăng ký khóa học đã tồn tại", "Mã đăng ký khóa học đã tồn tại"))
                  );
                }
              });
            }
          } else if (modeOpen === "create") {
            // console.log("create")
            await checkExistCodeName(value).then((res) => {
              if (res.data.data === true) {
                return Promise.reject(
                  new Error(t("Mã đăng ký khóa học đã tồn tại", "Mã đăng ký khóa học đã tồn tại"))
                );
              }
            });
          }
        }
        if (!value) {
          return Promise.reject(new Error(t(t("Vui lòng nhập mã đăng ký", "Vui lòng nhập mã đăng ký"), t("Vui lòng nhập mã đăng ký", "Vui lòng nhập mã đăng ký"))));
        }
        return Promise.resolve();
      },
    },
    registrationName: {
      required: true,
      // message: t(t("Vui lòng nhập tên đăng ký", "Vui lòng nhập tên đăng ký"), t("Vui lòng nhập tên đăng ký", "Vui lòng nhập tên đăng ký")),
      validator: (_: unknown, value: string) => {
        // if (value && value.length < 6) {
        //   return Promise.reject(
        //     new Error("Tên khóa học phải từ 6 ký tự trở lên")
        //   );
        // }
        if (value && value.length > 255) {
          return Promise.reject(
            new Error(t("Tên đăng ký khóa học không vượt quá 255 ký tự", "Tên đăng ký khóa học không vượt quá 255 ký tự"))
          );
        }
        if (!value) {
          return Promise.reject(new Error(t(t("Vui lòng nhập tên đăng ký", "Vui lòng nhập tên đăng ký"), t("Vui lòng nhập tên đăng ký", "Vui lòng nhập tên đăng ký"))));
        }
        return Promise.resolve();
      },
    },
    courseIndustry: {
      required: true,
      message: t("Vui lòng chọn khoa áp dụng", "Vui lòng chọn khoa áp dụng"),
      // validator: (_: unknown, value: string) => {
      //   value = "x";
      //   if (!value) {
      //     return Promise.reject(new Error(t("Vui lòng chọn khoa áp dụng", "Vui lòng chọn khoa áp dụng")));
      //   }
      //   return Promise.resolve();
      // },
    },
    courseStart: {
      required: false,
      message: t("Vui lòng chọn ngày", "Vui lòng chọn ngày"),
      // validator: (_: unknown, value: string) => {
      //   value = "x";
      //   if (!value) {
      //     return Promise.reject(new Error(t("Vui lòng chọn ngày", "Vui lòng chọn ngày")));
      //   }
      //   return Promise.resolve();
      // },
    },
    courseDuration: {
      required: false,
      message: t(t("Vui lòng nhâp thời gian dự kiến", "Vui lòng nhâp thời gian dự kiến"), t("Vui lòng nhâp thời gian dự kiến", "Vui lòng nhâp thời gian dự kiến")),
      // validator: (_: unknown, value: string) => {
      //   value = "x";
      //   if (!value) {
      //     return Promise.reject(new Error(t(t("Vui lòng nhâp thời gian dự kiến", "Vui lòng nhâp thời gian dự kiến"), t("Vui lòng nhâp thời gian dự kiến", "Vui lòng nhâp thời gian dự kiến"))));
      //   }
      //   return Promise.resolve();
      // },
    },

    constructionPlanStatus: {
      required: false,
      message: t("Vui lòng chọn khoa Title of construction_plan_status áp dụng", "Vui lòng chọn khoa Title of construction_plan_status áp dụng"),
      // validator: (_: unknown, value: string) => {
      //   value = "x";
      //   if (!value) {
      //     return Promise.reject(
      //       new Error(t("Vui lòng nhập tên Title of construction_plan_status", "Vui lòng nhập tên Title of construction_plan_status"))
      //     );
      //   }
      //   return Promise.resolve();
      // },
    },
    courseType: {
      required: true,
      message: t(t("Vui lòng chọn loại khóa học áp dụng", "Vui lòng chọn loại khóa học áp dụng"), t("Vui lòng chọn loại khóa học áp dụng", "Vui lòng chọn loại khóa học áp dụng")),
      // validator: (_: unknown, value: string) => {
      //   value = "x";
      //   if (!value) {
      //     return Promise.reject(new Error(t(t("Vui lòng chọn loại khóa học áp dụng", "Vui lòng chọn loại khóa học áp dụng"), t("Vui lòng chọn loại khóa học áp dụng", "Vui lòng chọn loại khóa học áp dụng"))));
      //   }
      //   return Promise.resolve();
      // },
    },
    registrationSubmissionDate: {
      required: true,
      message:
        t("Vui lòng chọn khoa Title of registration_submission_date áp dụng", "Vui lòng chọn khoa Title of registration_submission_date áp dụng"),
      // validator: (_: unknown, value: string) => {
      //   value = "x";
      //   if (!value) {
      //     return Promise.reject(
      //       new Error(t("Vui lòng nhập tên Title of registration_submission_date", "Vui lòng nhập tên Title of registration_submission_date"))
      //     );
      //   }
      //   return Promise.resolve();
      // },
    },
    registrationSubmitterId: {
      required: true,
      message: t("Vui lòng chọn khoa Title of registration_submitter_id áp dụng", "Vui lòng chọn khoa Title of registration_submitter_id áp dụng"),
      // validator: (_: unknown, value: string) => {
      //   value = "x";
      //   if (!value) {
      //     return Promise.reject(
      //       new Error(t("Vui lòng nhập tên Title of registration_submitter_id", "Vui lòng nhập tên Title of registration_submitter_id"))
      //     );
      //   }
      //   return Promise.resolve();
      // },
    },
    universityId: {
      required: true,
      message: t(t("Vui lòng chọn trường chủ trì áp dụng", "Vui lòng chọn trường chủ trì áp dụng"), t("Vui lòng chọn trường chủ trì áp dụng", "Vui lòng chọn trường chủ trì áp dụng")),
      // validator: (_: unknown, value: string) => {
      //   value = "x";
      //   if (!value) {
      //     return Promise.reject(
      //       new Error(t("Vui lòng nhập tên Title of university_id", "Vui lòng nhập tên Title of university_id"))
      //     );
      //   }
      //   return Promise.resolve();
      // },
    },
    // universityId: {
    //   required: true,
    //   message: t(t("Vui lòng chọn trường chủ trì áp dụng", "Vui lòng chọn trường chủ trì áp dụng"), t("Vui lòng chọn trường chủ trì áp dụng", "Vui lòng chọn trường chủ trì áp dụng")),
    //   // validator: (_: unknown, value: string) => {
    //   //   value = "x";
    //   //   if (!value) {
    //   //     return Promise.reject(
    //   //       new Error(t("Vui lòng nhập tên Title of university_id", "Vui lòng nhập tên Title of university_id"))
    //   //     );
    //   //   }
    //   //   return Promise.resolve();
    //   // },
    // },
    courseIndustryGroup: {
      required: true,
      message: t(t("Vui lòng chọn chuyên ngành đăng ký", "Vui lòng chọn chuyên ngành đăng ký"), t("Vui lòng chọn chuyên ngành đăng ký", "Vui lòng chọn chuyên ngành đăng ký")),
      // validator: (_: unknown, value: string) => {
      //   value = "x";
      //   if (!value) {
      //     return Promise.reject(new Error(t(t("Vui lòng chọn chuyên ngành đăng ký", "Vui lòng chọn chuyên ngành đăng ký"), t("Vui lòng chọn chuyên ngành đăng ký", "Vui lòng chọn chuyên ngành đăng ký"))));
      //   }
      //   return Promise.resolve();
      // },
    },
  };
  const dateFormat = "DD/MM/YYYY";
  const { TextArea } = Input;
  const onChange: DatePickerProps["onChange"] = (date, dateString) => {
    // console.log(date, dateString);
  };
  const [form] = Form.useForm();
  const [error, setError] = useState<any>({});
  const [detailDataEdit, setDetailDataEdit] =
    useState<DetailTypeMoocCourseConstructionPlan>(detailData!);
  const [listUniCollaborated, setListUniCollaborated] = useState<any[]>([]);
  const [universityHost, setUniversityHost] = useState<any[]>([]);
  useEffect(() => {
    form.resetFields();
    if (
      detailData !== null &&
      detailData !== undefined &&
      modeOpen === "edit"
    ) {
      // console.log(detailData?.moocConstructionPlanIndustryGroup.flatMap(
      //   (e: any) => e.mooc_industry_group
      // ));
      console.log(
        "Hello",
        detailData?.moocConstructionPlanCollaborator.flatMap(
          (e: any) => e.collaboratedUniversityId
        )
      );
      form.setFieldsValue({
        id: detailData?.id,
        registrationCode: detailData?.registrationCode,
        registrationName: detailData?.registrationName,
        courseStart: dayjs(detailData?.courseStart),
        courseDuration: detailData?.courseDuration,
        constructionPlanStatus: detailData?.constructionPlanStatus,
        courseType: detailData?.courseType,
        registrationSubmissionDate: dayjs(
          detailData?.registrationSubmissionDate
        ),
        registrationSubmitterId: detailData?.registrationSubmitterId,
        universityId: detailData?.universityId,
        registrationStageId: detailData?.registrationStageId,
        createdDate: dayjs(detailData?.createdDate),
        updatedDate: dayjs(detailData?.updatedDate),
        isDeleted: detailData?.isDeleted,
        moocApproval: detailData?.moocApproval,
        moocConstructionPlanCollaborator:
          detailData?.moocConstructionPlanCollaborator,

        lstIndustryIds:
          detailData?.moocConstructionPlanIndustry !== undefined &&
          detailData?.moocConstructionPlanIndustry.length > 0
            ? detailData?.moocConstructionPlanIndustry.flatMap(
                (e: any) => `${e.industryId}`
              )
            : [],

        lstIndustryGroupIds:
          detailData?.moocConstructionPlanIndustryGroup.length > 0
            ? detailData?.moocConstructionPlanIndustryGroup.flatMap(
                (e: any) => `${e.industryGroupId}`
              )
            : [],
        lstCollaboratedUniversityIds:
          detailData?.moocConstructionPlanCollaborator.length > 0
            ? detailData?.moocConstructionPlanCollaborator.flatMap(
                (e: any) => e.collaboratedUniversityId
              )
            : [],
        moocCourseConstructionPlan: detailData?.moocCourseConstructionPlan,
        otherMoocCourseConstructionPlan:
          detailData?.otherMoocCourseConstructionPlan,
        moocCoursePlanAssignment: detailData?.moocCoursePlanAssignment,
        moocCourseStructure: detailData?.moocCourseStructure,
      });
    }
  });

  useEffect(() => {
    //  console.log(modeOpen)
    form.resetFields();
    // if (id && id != 0) getDetailMoocCourseConstructionPlanData();
  }, [id]);
  const { getUserInfo } = useAuthStore((state) => {
    return {
      getUserInfo: state.user,
    };
  });
  const navigate = useNavigate();
  const onStartInput = () => {
    if (false) {
      //setError({ ...error, [`lecturerName`]: true });
      return;
    } else {
      form.submit();
    }
  };

  const [loading, setLoading] = useState<boolean>(true);

  // forgein key function call apis
  const [lstRegistrationSubmitterId, setLstRegistrationSubmitterId] = useState<
    any[]
  >([]);
  const [lstUniversityId, setLstUniversityId] = useState<any[]>([]);
  const [lstUniversityIdHost, setLstUniversityIdHost] = useState<any[]>([]);
  const [dataIndustry, setDataIndustry] = useState<any[]>([]);
  const [dataIndustryGroup, setDataIndustryGroup] = useState<any[]>([]);
  const [dataCourseType, setDataCourseType] = useState<any[]>([]);
  const getListLstRegistrationSubmitterId = async () => {
    try {
      await getLookupAuthUser()
        .then((res) => {
          const { data } = res.data;
          setLstRegistrationSubmitterId(
            data.map((item: any) => {
              if (!("name" in item)) item["name"] = item["id"];
              return item;
            })
          );
        })
        .catch((err) => {
          console.log(err);
          // message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
        });
    } catch (error) {
      console.log(error);
      message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
    }
  };

  const getListLstUniversityIdHost = async () => {
    try {
      await getLookupMoocUniversityHost()
        .then((res) => {
          const { data } = res.data;
          // console.log("truong");
          // console.log(data);
          const dataConvert: any[] = [];
          const universityHostFind = data.find(
            (u: any) => u.enterprise_id === getUserInfo?.enterpriseUUID
          );
          // form.resetFields();
          setUniversityHost([universityHostFind?.id]);
          data.forEach((e: any) => {
            dataConvert.push({
              value: e.id,
              label: e.name,
            });
          });

          // console.log(dataConvert);
          setLstUniversityIdHost(dataConvert);
        })
        .catch((err) => {
          console.log(err);
          message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
        });
    } catch (error) {
      console.log(error);
      message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
    }
  };
  const getListLstUniversityId = async () => {
    try {
      await getLookupMoocUniversity()
        .then((res) => {
          const { data } = res.data;
          // console.log("truong");
          // console.log(data);
          const dataConvert: any[] = [];
          data.forEach((e: any) => {
            dataConvert.push({
              value: e.id,
              label: e.name,
            });
          });
          // console.log("Hello", dataConvert);
          setLstUniversityId(dataConvert);
        })
        .catch((err) => {
          console.log(err);
          message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
        });
    } catch (error) {
      console.log(error);
      message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
    }
  };
  const getDataIndustry = async () => {
    try {
      setLoading(true);
      await getLookupIndustry()
        .then((res) => {
          const { data } = res.data;
          const dataConvert: any[] = [];
          data.forEach((e: any) => {
            dataConvert.push({
              value: `${e.id}`,
              label: e.name,
            });
          });

          setDataIndustry(dataConvert);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
      message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
    }
  };
  const getDataIndustryGroup = async () => {
    try {
      setLoading(true);
      await getLookupIndustryGroup()
        .then((res) => {
          const { data } = res.data;
          const dataConvert: any[] = [];
          data.forEach((e: any) => {
            dataConvert.push({
              value: `${e.id}`,
              label: e.name,
            });
          });

          setDataIndustryGroup(dataConvert);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
      message.error(t("Có lỗi chưa xác định", "Có lỗi chưa xác định"));
    }
  };
  const filterOption = (input: any, option: any) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  useEffect(() => {
    getListLstRegistrationSubmitterId();
    getListLstUniversityId();
    getListLstUniversityIdHost();
    getDataIndustry();
    getDataIndustryGroup();
    setDataCourseType([
      {
        label: t("Tự triển khai", "Tự triển khai"),
        value: 1,
      },
      {
        label: t("Hợp tác xây dựng", "Hợp tác xây dựng"),
        value: 2,
      },
      {
        label: t("Dùng chung", "Dùng chung"),
        value: 3,
      },
    ]);
  }, []);

  return (
    <>
      <DrawerCustom
        title={
          id && id !== 0 ? t("Chỉnh sửa kế hoạch", "Chỉnh sửa kế hoạch") : t("Thêm mới đăng ký kế hoạch", "Thêm mới đăng ký kế hoạch")
        }
        open={isOpened}
        onClose={() => {
          form.resetFields();
          // setIsShowCollaborated(false);
          //setDetailData({});

          setIsOpened(false);
          console.log("closed");
        }}
        extraNode={
          <Space>
            <Button
              onClick={() => {
                setIsOpened(false);
                //setDetailData({});
                form.resetFields();
              }}
              className="btn btn-outlined"
            >
              <CloseOutlined />
              <Typography.Text>{t("Huỷ", "Huỷ")}</Typography.Text>
            </Button>
            <Button
              className="btn btn-primary"
              htmlType="submit"
              onClick={onStartInput}
            >
              <SaveOutlined />
              <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
            </Button>
          </Space>
        }
        widthDrawer={736}
      >
        <Form
          className="form-create-edit"
          layout={"vertical"}
          form={form}
          onFinish={onFinish}
          name="create-edit-mooc-course-construction-plan-detail"
        >
          <Row gutter={24} style={{ marginBottom: 10 }}>
            <Col span={12}>
              <Form.Item
                name="registrationName"
                rules={[validations.registrationName]}
                label={t(t("Nhập tên đăng ký", "Nhập tên đăng ký"), t("Nhập tên đăng ký", "Nhập tên đăng ký"))}
                style={{ marginBottom: 5 }}
              >
                <FormInput placeholder={t(t("Nhập tên đăng ký", "Nhập tên đăng ký"), t("Nhập tên đăng ký", "Nhập tên đăng ký"))} />
              </Form.Item>
              <span className="label-down-text">
                {t("Tên hiển thị công khai cho đăng ký của bạn", "Tên hiển thị công khai cho đăng ký của bạn")}
              </span>
            </Col>
            <Col span={12}>
              <Form.Item
                name="registrationCode"
                rules={[validations.registrationCode]}
                label={t("Mã đăng ký", "Mã đăng ký")}
                style={{ marginBottom: 5 }}
              >
                <FormInput placeholder={t(t("Nhập mã đăng ký", "Nhập mã đăng ký"), t("Nhập mã đăng ký", "Nhập mã đăng ký"))} />
              </Form.Item>
              <span className="label-down-text">
                {t("Số định danh duy nhất xác định đăng ký của bạn", "Số định danh duy nhất xác định đăng ký của bạn")}
              </span>
            </Col>
          </Row>
          <Col span={24} style={{ marginBottom: 10 }}>
            <Form.Item
              name="lstIndustryIds"
              label="Khoa"
              rules={[validations.courseIndustry]}
            >
              <Select
                filterOption={filterOption}
                mode="multiple"
                options={dataIndustry}
                allowClear={true}
                placeholder={t(t("Chọn khoa đăng ký kế hoạch áp dụng", "Chọn khoa đăng ký kế hoạch áp dụng"), t("Chọn khoa đăng ký kế hoạch áp dụng", "Chọn khoa đăng ký kế hoạch áp dụng"))}
                onChange={(e) => {
                  console.log(dataIndustry);
                  console.log(e);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={24} style={{ marginBottom: 10 }}>
            <Form.Item
              name="lstIndustryGroupIds"
              label={t("Chuyên ngành", "Chuyên ngành")}
              rules={[validations.courseIndustryGroup]}
            >
              <Select
                filterOption={filterOption}
                mode="multiple"
                options={dataIndustryGroup}
                allowClear={true}
                placeholder={t("Chọn chuyên ngành đăng ký khóa học áp dụng", "Chọn chuyên ngành đăng ký khóa học áp dụng")}
              />
            </Form.Item>
          </Col>
          <Col span={24} style={{ marginBottom: 10 }}>
            <Form.Item
              name="courseType"
              label={t("Loại khóa học", "Loại khóa học")}
              rules={[validations.courseType]}
            >
              <Select
                showSearch
                optionFilterProp="children"
                options={dataCourseType}
                filterOption={filterOption}
                allowClear={true}
                placeholder={t(t("Chọn loại khóa học áp dụng", "Chọn loại khóa học áp dụng"), t("Chọn loại khóa học áp dụng", "Chọn loại khóa học áp dụng"))}
                // onChange={(e) => {
                //   listDataMemberUpdate[index].organizationMemberId =
                //     parseInt(e);
                //   setListDataMember(listDataMemberUpdate);
                // }}
              />
            </Form.Item>
          </Col>
          <Row gutter={24} style={{ marginBottom: 10 }}>
            <Col span={12}>
              <Form.Item
                name="courseStart"
                rules={[validations.courseStart]}
                label={t("Thời gian bắt đầu", "Thời gian bắt đầu")}
                style={{ marginBottom: 5 }}
              >
                <DatePicker placeholder={t("Chọn ngày", "Chọn ngày")} format={dateFormat} />
              </Form.Item>
              <span className="label-down-text">{t("Dự kiến thời gian bắt đầu khóa học", "Dự kiến thời gian bắt đầu khóa học")}</span>
            </Col>
            <Col span={12}>
              <Form.Item
                name="courseDuration"
                rules={[validations.courseDuration]}
                label={t("Thời lượng dự kiến", "Thời lượng dự kiến")}
                style={{ marginBottom: 5 }}
              >
                <Input type="number" placeholder={t(t("Nhập thời lượng dự kiến", "Nhập thời lượng dự kiến"), t("Nhập thời lượng dự kiến", "Nhập thời lượng dự kiến"))} />
              </Form.Item>
              <span className="label-down-text">{t("Dự kiến số lượng tín chỉ", "Dự kiến số lượng tín chỉ")}</span>
            </Col>
          </Row>

          <div style={{ marginTop: 20 }}>{t("Trường chủ trì đăng ký kế hoạch", "Trường chủ trì đăng ký kế hoạch")}</div>
          <Col span={24} style={{ marginTop: 10 }}>
            <Form.Item
              name="universityId"
              label={t("Trường chủ trì", "Trường chủ trì")}
              rules={[validations.universityId]}
              initialValue={universityHost}
            >
              <Select
                showSearch
                optionFilterProp="children"
                options={lstUniversityIdHost}
                filterOption={filterOption}
                allowClear={true}
                placeholder={t(t("Chọn trường đại học chủ trì", "Chọn trường đại học chủ trì"), t("Chọn trường đại học chủ trì", "Chọn trường đại học chủ trì"))}
              />
            </Form.Item>
          </Col>
          <div style={{ marginTop: 20 }}>{t("Trường hợp tác đăng ký kế hoạch", "Trường hợp tác đăng ký kế hoạch")}</div>
          <Col span={24} style={{ marginTop: 10 }}>
            <Form.Item
              name="lstCollaboratedUniversityIds"
              label={t("Trường hợp tác", "Trường hợp tác")}
              // rules={[validations.universityId]}
            >
              <Select
                showSearch
                mode="multiple"
                optionFilterProp="children"
                options={lstUniversityId}
                filterOption={filterOption}
                allowClear={true}
                placeholder={t(t("Chọn trường đại học hợp tác", "Chọn trường đại học hợp tác"), t("Chọn trường đại học hợp tác", "Chọn trường đại học hợp tác"))}
              />
            </Form.Item>
          </Col>
        </Form>
      </DrawerCustom>
    </>
  );
};
